import {APIClient} from '../backend/ApiClient';

export const useGetThumbnailFile = () => {
    const apiClient = APIClient();

    return (url: string, fileName: string) => {
        return apiClient.downloadThumbnailFile(url).then((data) => new File([data], fileName ? fileName : 'thumbnail'));
    };
};
